import { Component, ChangeDetectionStrategy } from '@angular/core';
import { Settings } from '../../../core';

@Component({
    selector: 'report-types',
    template: require('./report-types.component.html'),
    styles: [require('./report-types.component.scss')],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class SampleTrackingReportTypesComponent {
    private smiReportTooltip: string;
    private stReportTooltip: string;
    constructor(private settings: Settings) {
        this.smiReportTooltip = this.settings.specimenManagementInventoryReportHelpText;
        this.stReportTooltip = this.settings.sampleTrackingReportHelpText;
    }
}
